export const createPartner = {
    "titles": {
        "page": "Create or edit partner",
        "create": "Create partner",
        "update": "Update partner",
        "chatAdmins": "צ׳ט לאדמינים בלינק"
    },
    "labels": {
        "name": "Partner name",
        "shortcut": "Partner English shortcut",
        "select": "Select partner",
        "logo": "Partner logo"
    },
    "btns": {
        "create": "Create partner",
        "update": "Update partner"
    },
    "logoUploaded": "Logo was successfully uploaded"
};
